/**
 * 休暇届 (Leave Notification) - Matches Excel template
 */
export default function LeavePrintSheet({ submission }) {
  const data = submission.form_data || {};
  const leaveType = data.leave_type || '';
  const today = new Date(submission.created_at);
  const submitYear = today.getFullYear();
  const submitMonth = today.getMonth() + 1;
  const submitDay = today.getDate();

  let leaveMonth = '', leaveDay = '';
  if (data.leave_date) {
    const d = new Date(data.leave_date);
    if (!isNaN(d.getTime())) {
      leaveMonth = d.getMonth() + 1;
      leaveDay = d.getDate();
    }
  }

  let endMonth = '', endDay = '';
  if (data.leave_end_date) {
    const d = new Date(data.leave_end_date);
    if (!isNaN(d.getTime())) {
      endMonth = d.getMonth() + 1;
      endDay = d.getDate();
    }
  }

  // Display string: "6 月　21 日" / "6 月　21-22 日" / "6/21 〜 7/2"
  let leaveDisplay = '';
  if (leaveMonth) {
    if (!endDay || (endMonth === leaveMonth && endDay === leaveDay)) {
      leaveDisplay = `${leaveMonth} 月　　${leaveDay} 日`;
    } else if (endMonth === leaveMonth) {
      leaveDisplay = `${leaveMonth} 月　　${leaveDay}-${endDay} 日`;
    } else {
      leaveDisplay = `${leaveMonth}/${leaveDay} 〜 ${endMonth}/${endDay}`;
    }
  }

  // Mark selection — which option column is selected
  const isPaid = leaveType === '有給休暇';
  const isAmHalf = leaveType === '午前半休';
  const isPmHalf = leaveType === '午後半休';
  const isOther = leaveType === 'その他';

  const Ring = ({ show, children, style }) => (
    <span style={{ position: 'relative', display: 'inline-block', padding: '4px 10px', ...style }}>
      {children}
      {show && (
        <span
          aria-hidden="true"
          style={{
            position: 'absolute', top: '-3px', bottom: '-3px', left: '-3px', right: '-3px',
            border: '1.5px solid #000', borderRadius: '50%',
          }}
        />
      )}
    </span>
  );

  const labelCellStyle = {
    border: '1px solid #000',
    padding: '8px 6px',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontSize: '13px',
  };

  return (
    <div
      className="print-form"
      style={{
        padding: '8mm',
        fontFamily: "'IBM Plex Sans JP', 'Yu Gothic', sans-serif",
        color: '#000',
        background: '#fff',
        boxSizing: 'border-box',
      }}
    >
      {/* Header */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '14px' }}>
        <tbody>
          <tr>
            <td style={{ verticalAlign: 'top', width: '50%' }}>
              <span style={{ borderBottom: '1px solid #000', padding: '2px 10px', fontSize: '11px', display: 'inline-block' }}>
                管理本部　殿
              </span>
            </td>
            <td style={{ verticalAlign: 'top', width: '50%', textAlign: 'right', fontSize: '12px' }}>
              提出日　
              <span style={{ padding: '0 6px' }}>{submitYear}</span>年
              <span style={{ padding: '0 6px' }}>{submitMonth}</span>月
              <span style={{ padding: '0 6px' }}>{submitDay}</span>日
            </td>
          </tr>
        </tbody>
      </table>

      {/* Title */}
      <h1
        style={{
          textAlign: 'center',
          fontSize: '24px',
          fontWeight: 'bold',
          letterSpacing: '0.6em',
          margin: '16px 0 28px 0',
          paddingBottom: '4px',
          textDecoration: 'underline',
          textUnderlineOffset: '6px',
        }}
      >
        休　暇　届
      </h1>

      {/* Applicant info — full-width underline */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '14px' }}>
        <tbody>
          <tr style={{ borderBottom: '1px solid #000' }}>
            <td style={{ width: '22%', fontSize: '12px', fontWeight: 'bold', verticalAlign: 'bottom', padding: '0 4px 4px 0' }}>
              ID・個人コード・氏名
            </td>
            <td style={{ width: '70%', padding: '4px 8px', fontSize: '13px', verticalAlign: 'bottom' }}>
              {data.id_card ? `${data.id_card}・` : ''}{data.employee_code ? `${data.employee_code}・` : ''}{data.employee_name || ''}
            </td>
            <td style={{ width: '8%', textAlign: 'right', fontSize: '11px', verticalAlign: 'bottom', padding: '0 8px 4px 0' }}>印</td>
          </tr>
        </tbody>
      </table>

      <div style={{ fontSize: '11px', margin: '14px 0 4px 0' }}>※該当する休暇に○印をつけてください。</div>

      {/* Leave type grid */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '26px', tableLayout: 'fixed' }}>
        <tbody>
          {/* Row 1 */}
          <tr>
            <td
              rowSpan={2}
              style={{
                border: '1px solid #000',
                padding: '8px 4px',
                width: '12%',
                fontSize: '11px',
                fontWeight: 'bold',
                textAlign: 'center',
                verticalAlign: 'middle',
              }}
            >
              休暇<br />種類
            </td>

            {/* 有休 (rowSpan 2) — ○ centered on the label */}
            <td rowSpan={2} style={{ ...labelCellStyle, width: '25%' }}>
              <Ring show={isPaid}>有休</Ring>
            </td>

            {/* 午前半休 (top half) */}
            <td style={{ ...labelCellStyle, width: '29%' }}>
              <Ring show={isAmHalf}>午前半休</Ring>
            </td>

            {/* その他 (rowSpan 2) */}
            <td rowSpan={2} style={{ ...labelCellStyle, width: '34%' }}>
              <Ring show={isOther}>
                <div>その他</div>
                <div style={{ marginTop: '4px' }}>（　{data.other_label || '　　'}　）</div>
              </Ring>
            </td>
          </tr>

          {/* Row 2 */}
          <tr>
            {/* 午後半休 (bottom half) */}
            <td style={labelCellStyle}>
              <Ring show={isPmHalf}>午後半休</Ring>
            </td>
          </tr>
        </tbody>
      </table>

      {/* Bottom row: 取得日 box (left) + 所属長承認印 box (right, standalone) */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '6px', tableLayout: 'fixed' }}>
        <tbody>
          <tr>
            <td style={{ width: '74%', verticalAlign: 'top', padding: 0 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr>
                    <td style={{
                      border: '1px solid #000',
                      width: '20%',
                      padding: '10px 6px',
                      fontWeight: 'bold',
                      fontSize: '12px',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                      height: '54px',
                    }}>
                      取得日
                    </td>
                    <td style={{
                      border: '1px solid #000',
                      padding: '10px',
                      fontSize: '14px',
                      textAlign: 'center',
                      verticalAlign: 'middle',
                    }}>
                      {leaveDisplay}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>

            {/* spacer */}
            <td style={{ width: '4%', padding: 0 }}></td>

            {/* 所属長承認印 standalone box — smaller, sign-only */}
            <td style={{ width: '16%', verticalAlign: 'top', padding: 0 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr>
                    <td style={{
                      border: '1px solid #000',
                      padding: '2px 4px',
                      fontSize: '9px',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      height: '14px',
                      lineHeight: '1',
                    }}>
                      所属長承認印
                    </td>
                  </tr>
                  <tr>
                    <td style={{
                      border: '1px solid #000',
                      borderTop: 'none',
                      height: '52px',
                    }}></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>

      {/* 事由 — underline only under the 取得日 width (not under stamp box) */}
      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px', tableLayout: 'fixed' }}>
        <tbody>
          <tr>
            <td style={{ width: '8%', fontSize: '13px', fontWeight: 'bold', verticalAlign: 'bottom', padding: '0 4px 4px 0' }}>
              事由
            </td>
            <td style={{ width: '66%', borderBottom: '1px solid #000', padding: '4px 8px', fontSize: '13px', whiteSpace: 'pre-wrap', minHeight: '20px' }}>
              {data.reason || ''}
            </td>
            <td style={{ width: '26%' }}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
